import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { CleanIcon, DeleteIcon, EditIcon, ExisIcon, CheckIcon, DownloadIcon, } from 'assets/icons';
import { Table, Pagination, DatePicker, Tooltip, Input, Select, Modal } from 'components';
import { AdvertisementService } from 'services';
import moment from 'moment';
import { Globals, Constants, checkPermission } from 'utils';
import ModalCreate from './modal-create';
import { Button } from "react-bootstrap";

const INITIAL_STATE = {
	since: '',
	until: '',
	search: '',
	status: '',
	valid: '',
	advertising_rate_id: '',
	type: Constants.ADVERTISEMENTS.TYPE.BANNERS,
};

class Banner extends React.Component<any> {
	timer: any = undefined;

	state = {
		data: [],
		page: 1,
		last_page: 1,
		header: [
			'Fecha de solicitud',
			'Nombre',
			'Tipo de Usuario',
			'CI/RIF',
			'Tipo de Banner',
			'Banners',
			'Tiempo contratado',
			'Fecha de aprobación',
			'Estatus',
			'Vigencia',
			'Acciones',
		],
		form: INITIAL_STATE,
		visible: false,
		item: null,
		advertisingRates: [],
		bannerPreviewVisible: false,
		bannerPreviewItem: null as any,
		bannersTotals: [] as any[],
	};

	componentDidMount() {
		this.getAdvertisingRates();
		this.load();
	}

	getAdvertisingRates = async () => {
		try {
			const res: any = await AdvertisementService.admin.getAdvertisingRates({
				...this.state.form,
			});

			const rates = res.advertisingRates;
			const formattedRates = rates.map((rate: any) => ({
				value: String(rate.id),
				label: rate.name,
			}));

			const defaultOption = { value: '', label: 'Todos' };

			this.setState({
				advertisingRates: [defaultOption, ...formattedRates],
			});
		} catch (error) {
			console.error('Error al obtener las tarifas de publicidad:', error);
		}
	};

	load = async (withoutLoading: boolean = false) => {
		const res: any = await AdvertisementService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since:
				this.state.form.since &&
				moment(this.state.form.since).format('YYYY-MM-DD'),
			until:
				this.state.form.until &&
				moment(this.state.form.until).format('YYYY-MM-DD'),
		});

		this.setState({
			data: res.advertisements.rows,
			last_page: res.advertisements.count,
			bannersTotals: res.banners_totals || [],
		});
	};

	applyFilters = () => {
		this.setState(
			{
				page: 1,
			},
			() => this.load(true),
		);
	};

	reset = () => {
		this.setState(
			{
				form: INITIAL_STATE,
				page: 1,
			},
			() => this.load(true),
		);
	};

	change = (e: any, callback = () => { }) => {
		this.setState(
			{
				page: 1,
				form: {
					...this.state.form,
					[e.target.name]: e.target.value,
				},
			},
			callback,
		);
	};

	print = async () => {
		const res: any = await AdvertisementService.admin.get({
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			download: true,
		});

		if (res.url) {
			const link = document.createElement('a');
			link.href = res.url;
			link.download = res.url.split('/').pop();
			link.target = '_blank';
			link.click();
			link.remove();
		}
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el banner?', async () => {
			await AdvertisementService.admin.delete({
				id: item.id,
			});
			this.load(true);
		});
	};

	approve = async (e: any, item: any) => {
		e.preventDefault();

		Globals.confirm(`¿Desea aprobar este banner?`, async () => {
			try {
				await AdvertisementService.admin.approve({
					id: item.id,
				});

				this.load(true);
				Globals.showSuccess('Banner aprobado exitosamente.');

			} catch (error) {
				const err = error as any;
				console.error('Error al aprobar:', err.response?.data);

				const responseData = err.response?.data;
				const backendMessage = responseData?.error
					|| responseData?.message
					|| 'Ocurrió un error inesperado al aprobar el banner.';

				Globals.showError(backendMessage);
			}
		});
	};

	reject = async (e: any, item: any) => {
		e.preventDefault();

		Globals.confirm(`¿Desea rechazar este banner?`, async () => {
			try {
				await AdvertisementService.admin.approve({
					id: item.id,
					reject: true,
				});

				this.load(true);
				Globals.showSuccess('Banner rechazado.');

			} catch (error) {
				const err = error as any;
				const responseData = err.response?.data;
				const backendMessage = responseData?.error
					|| responseData?.message
					|| 'Ocurrió un error inesperado al rechazar el banner.';

				Globals.showError(backendMessage);
			}
		});
	};

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item,
		});
	};

	onClose = () => {
		this.setState(
			{
				visible: false,
				item: null,
			},
			() => this.load(true),
		);
	};

	openBannerPreview = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			bannerPreviewVisible: true,
			bannerPreviewItem: item,
		});
	};

	closeBannerPreview = () => {
		this.setState({
			bannerPreviewVisible: false,
			bannerPreviewItem: null,
		});
	};

	canReset = () => {
		return JSON.stringify(this.state.form) !== JSON.stringify(INITIAL_STATE);
	};

	render() {
		const { bannerPreviewVisible, bannerPreviewItem, bannersTotals, visible } = this.state;

		const previewImageUrl =
			bannerPreviewItem &&
				bannerPreviewItem.details &&
				bannerPreviewItem.details[0]?.image
				? `${Constants.BASE_STORAGE}${bannerPreviewItem.details[0].image}`
				: '';

		return (
			<div id="admin-classified">
				<Modal
					className="banner-preview-modal"
					visible={bannerPreviewVisible}
					onClose={this.closeBannerPreview}
					title="Banner Principal"
				>
					<div className="banner-preview-container">
						{previewImageUrl && (
							<div className="banner-preview-img-wrapper">
								<img src={previewImageUrl} alt="Banner principal" />
							</div>
						)}
					</div>
				</Modal>

				<Modal
					className="modal-create-banner"
					visible={visible}
					withoutClose={true}
					onClose={() => this.onClose()}
				>
					<ModalCreate
						item={this.state.item}
						onClose={() => this.onClose()}
					/>
				</Modal>

				<div className="row row-filter d-flex flex-wrap align-items-end">
					<div className="col-md-2">
						<Input
							value={this.state.form.search}
							name="search"
							label="Buscar por nombre o CI/RIF"
							placeholder="Buscar"
							className="input-table"
							onChange={this.change}
						/>
					</div>

					<div className="col-md-2">
						<Select
							label="Tipo de Banner"
							name="advertising_rate_id"
							onChange={this.change}
							value={this.state.form.advertising_rate_id}
							options={this.state.advertisingRates}
						/>
					</div>

					<div className="col-md-2">
						<Select
							label="Estatus"
							name="status"
							onChange={this.change}
							value={this.state.form.status}
							options={[
								{ value: '', label: 'Todos' },
								{ value: '0', label: 'Pendientes' },
								{ value: '1', label: 'Aprobados' },
								{ value: '2', label: 'Rechazados' },
							]}
						/>
					</div>

					<div className="col-md-2">
						<Select
							label="Vigencia"
							name="valid"
							onChange={this.change}
							value={this.state.form.valid}
							options={[
								{ value: '', label: 'Todas' },
								{ value: 'Vigente', label: 'Vigente' },
								{ value: 'Vencido', label: 'Vencido' },
							]}
						/>
					</div>

					<div className="col-md-2">
						<DatePicker
							placeholder="Desde"
							onChange={(text: string) => {
								this.change({ target: { value: text, name: 'since' } });
							}}
							value={this.state.form.since}
						/>
					</div>

					<div className="col-md-2">
						<DatePicker
							placeholder="Hasta"
							onChange={(text: string) => {
								this.change({ target: { value: text, name: 'until' } });
							}}
							value={this.state.form.until}
						/>
					</div>

					<div className="col-md-2 filter-actions">
						<Button className="btn-filter" onClick={this.applyFilters}>
							Filtrar
						</Button>
						{this.canReset() && (
							<button className="btn btn-clean" onClick={this.reset}>
								<img src={CleanIcon} alt="Limpiar filtros" />
							</button>
						)}
					</div>
				</div>

				{this.props.tabs}

				{/* Tabla de Resumen de Disponibilidad */}
				{bannersTotals && bannersTotals.length > 0 && (
					<div className="summary-banners-wrapper mb-4">
						<h5 className="summary-title">Disponibilidad de Banners</h5>
						<div className="table-responsive">
							<table className="summary-table">
								<thead>
									<tr>
										<th>Tipo de Banner</th>
										<th className="text-center">Límite</th>
										<th className="text-center">En Uso</th>
										<th className="text-center">Disponibles</th>
									</tr>
								</thead>
								<tbody>
									{bannersTotals.map((bt: any) => (
										<tr key={bt.id} className={bt.is_full ? 'row-full' : ''}>
											<td className="font-weight-bold">{bt.name}</td>
											<td className="text-center">{bt.limit}</td>
											<td className="text-center">{bt.active_count}</td>
											<td className="text-center">
												{bt.is_full ? (
													<span className="badge badge-danger">Agotado</span>
												) : (
													<span className="badge badge-success">{bt.available_spaces}</span>
												)}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				)}

				<Table
					title="Registro de banners"
					data={this.state.data.length}
					rightAlign={[9]}
					header={this.state.header}
					titleRight={
						<Button className="btn-download" onClick={() => this.print()}>
							<img src={DownloadIcon} alt="Descargar Excel" />
							<span>Descargar Excel</span>
						</Button>
					}
				>
					{this.state.data.map((i: any, index: number) => {
						const hasImage =
							i.details &&
							i.details[0] &&
							i.details[0].image;

						return (
							<tr key={index}>
								<td>{moment(i.created_at).format('DD-MM-YYYY')}</td>
								<td>{i.user?.name || ''}</td>
								<td>{i.user?.level?.name || ''}</td>
								<td>
									{i.user?.document_type?.name}
									{i.user?.document}
								</td>
								<td>{i.advertising_rate?.name || ''}</td>
								<td>
									{hasImage ? (
										<a
											href="#"
											className="banner-view-link"
											onClick={(e: any) =>
												this.openBannerPreview(e, i)
											}
										>
											Ver
										</a>
									) : (
										''
									)}
								</td>
								<td>{i.days}</td>
								<td>
									{i.approval_date
										? moment(i.approval_date).format('DD-MM-YYYY')
										: '-'}
								</td>
								<td>{i.status_txt}</td>
								<td>{i.valid_txt}</td>
								<td className="actions">
									{checkPermission(
										Constants.MODULES.REGISTER,
										'write',
										this.props.user,
									) && (
											<Tooltip title="Editar">
												<a
													className="link-icon"
													href="#"
													onClick={(e: any) => this.edit(e, i)}
												>
													<img src={EditIcon} />
												</a>
											</Tooltip>
										)}
									{checkPermission(
										Constants.MODULES.REGISTER,
										'delete',
										this.props.user,
									) && (
											<Tooltip title="Eliminar">
												<a
													className="link-icon"
													href="#"
													onClick={(e: any) =>
														this.delete(e, i)
													}
												>
													<img src={DeleteIcon} />
												</a>
											</Tooltip>
										)}
									{checkPermission(
										Constants.MODULES.REGISTER,
										'write',
										this.props.user,
									) &&
										i.status ===
										Constants.USER_STATUS.INACTIVE && (
											<Tooltip title="Aprobar">
												<a
													className="link-icon"
													href="#"
													onClick={(e: any) =>
														this.approve(e, i)
													}
												>
													<img src={CheckIcon} />
												</a>
											</Tooltip>
										)}

									{checkPermission(
										Constants.MODULES.REGISTER,
										'write',
										this.props.user,
									) &&
										i.status ===
										Constants.USER_STATUS.INACTIVE && (
											<Tooltip title="Rechazar">
												<a
													className="link-icon"
													href="#"
													onClick={(e: any) =>
														this.reject(e, i)
													}
												>
													<img src={ExisIcon} />
												</a>
											</Tooltip>
										)}
								</td>
							</tr>
						);
					})}
				</Table>

				<Pagination
					pages={this.state.last_page}
					active={this.state.page}
					onChange={async (page: number) => {
						await this.setState({
							page: page,
						});
						this.load();
					}}
				/>

				<style>
					{`
		.banner-view-link {
			color: #000;
			text-decoration: underline;
			cursor: pointer;
			font-weight: 500;
		}

		.banner-view-link:hover {
			opacity: 0.8;
		}

		.banner-preview-modal .modal-content {
			background: #ffffff;
			border-radius: 10px;
			width: 332px;
			max-width: 90vw;
		}

		.banner-preview-modal .modal-body {
			padding: 16px;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.banner-preview-container {
			width: 300px;
			height: 300px;
			background: #ffffff;
			border-radius: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
		}

		.banner-preview-img-wrapper {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.banner-preview-img-wrapper img {
			max-width: 100%;
			max-height: 100%;
			width: auto;
			height: auto;
			object-fit: contain;
			display: block;
		}

		/* ---------- Estilos de la tabla de Resumen de Banners ---------- */
		.summary-banners-wrapper {
			background: #ffffff;
			border-radius: 8px;
			padding: 20px;
			box-shadow: 0 2px 4px rgba(0,0,0,0.05);
			border: 1px solid #e0e0e0;
		}

		.summary-title {
			color: #4B6E22; /* Ajustado al verde corporativo de la interfaz */
			font-size: 16px;
			font-weight: 700;
			margin-bottom: 15px;
		}

		.summary-table {
			width: 100%;
			border-collapse: collapse;
		}

		.summary-table th {
			background-color: #f8f9fa;
			color: #333;
			font-size: 13px;
			font-weight: 600;
			padding: 10px 15px;
			border-bottom: 2px solid #dee2e6;
		}

		.summary-table td {
			padding: 12px 15px;
			font-size: 14px;
			color: #555;
			border-bottom: 1px solid #eee;
			vertical-align: middle;
		}

		.summary-table tbody tr:hover {
			background-color: #fcfcfc;
		}

		.summary-table .row-full {
			background-color: #fff5f5;
		}
		.summary-table .row-full:hover {
			background-color: #ffebeb;
		}

		.badge {
			padding: 6px 12px;
			border-radius: 20px;
			font-size: 12px;
			font-weight: 600;
		}

		.badge-success {
			background-color: #e6f4ea;
			color: #1e8e3e;
		}

		.badge-danger {
			background-color: #fce8e6;
			color: #d93025;
		}
	`}
				</style>
			</div>
		);
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user,
	};
})(Banner);